module.exports = __webpack_public_path__ + "static/img/356.2330a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/356.jpg
// module id = oz8h
// module chunks = 0